import { render, staticRenderFns } from "./SimpleExamModelCards.vue?vue&type=template&id=26bd07da&"
import script from "./SimpleExamModelCards.vue?vue&type=script&lang=js&"
export * from "./SimpleExamModelCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports